module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Flip-vertical-626d7fb21565bafcc0e4f492908a92ee.svg";